<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <title>查看已填内容</title>
      <defs>
        <linearGradient id="largeGradient" x2="100%">
          <stop offset="0%" stop-color="#4c7eaf"></stop>
          <stop offset="25%" stop-color="#4a8eac"></stop>
          <stop offset="50%" stop-color="#46a5a7"></stop>
          <stop offset="75%" stop-color="#53bfac"></stop>
          <stop offset="100%" stop-color="#828282"></stop>
        </linearGradient>
      </defs>
      <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="提交答卷后的场景汇总1" transform="translate(-152.000000, -245.000000)">
          <g id="编组-2" transform="translate(16.000000, 104.000000)">
            <g id="查看已填内容" transform="translate(136.000000, 141.000000)">
              <rect id="矩形" fill="#A4B4CD" fill-rule="nonzero" opacity="0" x="0" y="0" width="24" height="24"></rect>
              <path
                d="M5.91316018,2.0138586 C6.00431289,2.89769854 6.27669731,3.31547085 6.61026344,3.64903698 C7.06116125,4.09993479 7.68407077,4.37882088 8.37211763,4.37882088 L8.37211763,4.37882088 L15.53867,4.37882088 C16.2267168,4.37882088 16.8496264,4.09993479 17.3005242,3.64903698 C17.6263481,3.32321306 17.8623531,2.90757026 17.968213,2.44243483 L17.968213,2.44243483 L19.5735058,2.01750499 C19.9058104,2.04239247 20.2039526,2.18840366 20.4242676,2.41133624 C20.6633544,2.65326365 20.8107876,2.98577317 20.8107876,3.35237882 L20.8107876,3.35237882 L20.8107876,21.6111306 C20.8107876,22.0590448 20.6328664,22.4886171 20.3161444,22.8053428 C19.9994246,23.1220663 19.5698582,23.3 19.1219462,23.3 L19.1219462,23.3 L4.78884145,23.3 C4.34092942,23.3 3.91136299,23.1220663 3.59464321,22.8053428 C3.27792126,22.4886171 3.1,22.0590448 3.1,21.6111306 L3.1,21.6111306 L3.1,3.70272805 C3.1,3.25481384 3.27792126,2.82524147 3.59464321,2.50851581 C3.91136299,2.19179232 4.34092942,2.0138586 4.78884145,2.0138586 L4.78884145,2.0138586 Z"
                id="形状"
                stroke="red"
                stroke-width="1.4"
                fill-rule="nonzero"
              >
                <animate attributeName="stroke" from="red" to="blue" dur="3s" repeatCount="indefinite"></animate>
              </path>
              <rect id="矩形" fill="#2775E8" x="7.4" y="1.3" width="9" height="1.4" rx="0.7">
                <animate attributeName="fill" from="red" to="blue" dur="3s" repeatCount="indefinite"></animate>
              </rect>
              <path
                d="M16.9772315,11.1910174 L11.1172315,16.6710174 C10.8732315,16.9030174 10.5572315,17.0150174 10.2412315,17.0150174 C9.90123146,17.0150174 9.56523146,16.8830174 9.31323146,16.6190174 L6.82923146,14.0190174 C6.51323145,13.6870174 6.52523145,13.1590174 6.85723146,12.8430174 C7.18923146,12.5270174 7.71723146,12.5390174 8.03323146,12.8710174 L10.2572315,15.1990174 L15.8412315,9.97501739 C16.1772315,9.65901739 16.7052315,9.6790174 17.0172315,10.0150174 C17.3332315,10.3510174 17.3132314,10.8790174 16.9772315,11.1910174 Z"
                id="路径"
                fill="url(#largeGradient)"
                fill-rule="nonzero"
              >
                <animate attributeName="fill" from="red" to="blue" dur="3s" repeatCount="indefinite"></animate>
              </path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ShowContentSvg'
}
</script>

<style scoped></style>
